module.exports = __webpack_public_path__ + "img/logo.11700b15.png";